/* eslint-disable */
const constants = (key) => process.env[`REACT_APP_${key}`];

const DefaultColor = 'rgb(179 71 1)';
const colorPrimaryBlue = 'rgb(25 118 210)';

const libraries = ['places', 'geometry', 'visualization', 'drawing'];

const MapTypesID = ['satellite', 'roadmap', 'hybrid', 'terrain'];

const hostName =
	window.location.hostname === 'localhost'
		? 'http://localhost:3000'
		: `http://${window.location.hostname}`;

const mapContainerStyle = {
	height: '100%',
	width: '100%',
};

const demoPolygons = [
	[
		{ lat: 16.296836502682254, lng: 80.56485318630246 },
		{ lat: 16.29667173845505, lng: 80.57099008052853 },
		{ lat: 16.290698941705134, lng: 80.5696167895129 },
		{ lat: 16.295188854176924, lng: 80.56270741909054 },
	],
];

const isLocalEnv = constants('env') === 'local';

// By default area is calculated in sq metres. 1 sq metre = 0.0002471054 acres
const AREA_CONVERSION_FACTOR = 0.0002471054;

const TOTAL_SECONDS_IN_A_DAY = 86400;

const APP_NAMES = {
	AWD: 'awd',
	TELEMATICS: 'telematics',
	VIEW: 'view',
	SUGARCANE: 'sugarcane',
	COMMON_PROGRAMS: 'programs',
};

// const center = {
// 	lat: 16.7566,
// 	lng: 81.677,
// };

const center = {
	lat: 17.1623717,
	lng: 79.9196817,
};

const Layers = ['FARMS', 'POLITICAL'];

const Colors = [
	'rgba(255, 99, 71, 1)',
	'rgba(255, 99, 71, 0.2)',
	'rgba(208, 214, 71, 0.5)',
	'rgba(208, 214, 253, 0.5)',
	'rgba(208, 214, 141, 0.7)',
	'rgba(34, 214, 141, 0.7)',
	'rgba(34, 88, 141, 0.7)',
	'rgba(34, 88, 226, 0.7)',
	'rgba(34, 88, 49, 0.7)',
	'rgba(110, 0, 49, 0.7)',
	'rgba(27, 149, 18, 0.3)',
];

const demoRequest = [
	{
		zoom: 18,
		tileX: 190561,
		tileY: 118670,
	},
	{
		zoom: 18,
		tileX: 190561,
		tileY: 118671,
	},
	{
		zoom: 18,
		tileX: 190562,
		tileY: 118670,
	},
	{
		zoom: 18,
		tileX: 190562,
		tileY: 118671,
	},
	{
		zoom: 18,
		tileX: 190563,
		tileY: 118670,
	},
	{
		zoom: 18,
		tileX: 190563,
		tileY: 118671,
	},
];

const TEMPORAL_PLACES_ENUMS = {
	POLYGONS: {
		namespace: 'FARMS',
		sourceType: 'MACHINE_BATCH_SPRAY',
		visibleType: 'VILLAGE_FARM',
	},
	PRUNED_POINTS: {
		namespace: 'IOT_PINGS',
		sourceType: 'IOT_GATEWAY_TYPE',
		visibleType: 'ENTITY_TYPE_PRUNED_POINTS',
	},
	POINTS: {
		namespace: 'IOT_PINGS',
		sourceType: 'IOT_GATEWAY_TYPE',
		visibleType: 'ENTITY_TYPE_RAW_POINTS',
	},
	DRY_RUN: {
		namespace: 'FARMS',
		sourceType: 'TRACE_SEGMENT',
		visibleType: 'VILLAGE_FARM',
	},
};

const TELEMATICS_MAX_DAYS = 7;

const PLACE_SOURCE_TYPES = {
	PIPE_INSTALLATION_SRC: 'PIPE_INSTALLATION_SRC',
	USER_FARM: 'USER_FARM',
	INSIDE_BUND_SRC: 'INSIDE_BUND_SRC',
	AWD_SOUTH_2021: 'AWD_SOUTH_2021',
	SATELLITE_FARM: 'SATELLITE_FARM',
	IOT_GATEWAY_TYPE: 'IOT_GATEWAY_TYPE',
};

export {
	AREA_CONVERSION_FACTOR,
	APP_NAMES,
	center,
	Colors,
	constants,
	colorPrimaryBlue,
	demoRequest,
	demoPolygons,
	DefaultColor,
	hostName,
	isLocalEnv,
	Layers,
	libraries,
	MapTypesID,
	mapContainerStyle,
	TEMPORAL_PLACES_ENUMS,
	TELEMATICS_MAX_DAYS,
	TOTAL_SECONDS_IN_A_DAY,
	PLACE_SOURCE_TYPES,
};
